import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransitionOverlayService } from '@core/services/transition-overlay.service';

@Component({
  selector: 'app-transition-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-transition-overlay.component.html',
  styleUrl: './app-transition-overlay.component.css',
})
export class AppTransitionOverlayComponent {
  readonly overlayService = inject(TransitionOverlayService);
}
